export const WO_MODES = [
  { value: 'DIRECT', label: 'Direct — vendor already chosen' },
  { value: 'BID', label: 'Invite / Open bid — collect quotations' },
];

export const WO_STATUSES = [
  'DRAFT',
  'PUBLISHED',
  'AWARDED',
  'ISSUED',
  'IN_PROGRESS',
  'ON_HOLD',
  'COMPLETED',
  'CLOSED',
  'CANCELLED',
];

export const WO_WORKFLOW_STAGES = [
  { key: 'DRAFT', label: 'Draft' },
  { key: 'ISSUED', label: 'Issued' },
  { key: 'IN_PROGRESS', label: 'In progress' },
  { key: 'COMPLETED', label: 'Completed' },
  { key: 'CLOSED', label: 'Closed' },
];

export const WO_BID_WORKFLOW_STAGES = [
  { key: 'DRAFT', label: 'Draft' },
  { key: 'PUBLISHED', label: 'Published' },
  { key: 'ISSUED', label: 'Issued' },
  { key: 'IN_PROGRESS', label: 'In progress' },
  { key: 'COMPLETED', label: 'Completed' },
  { key: 'CLOSED', label: 'Closed' },
];

export const WO_TYPE_SUGGESTIONS = [
  'Maintenance',
  'Biomedical Equipment',
  'Facility',
  'Electrical',
  'Plumbing',
  'HVAC / AC',
  'Civil / Renovation',
  'IT / Network / CCTV',
  'Medical Gas',
  'Generator',
  'Housekeeping',
  'Security',
  'Laundry',
  'Ambulance / Vehicle',
  'Outsourced Medical',
  'AMC / CMC',
  'Manpower / Contract Staff',
  'General Service',
  'Other',
];

export const WO_PRIORITY_SUGGESTIONS = ['Low', 'Medium', 'High', 'Critical'];

export { GST_RATE_OPTIONS, MAX_RFQ_ATTACHMENT_BYTES, ALLOWED_RFQ_ATTACHMENT_MIME } from './rfqManagement';
